import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import _ from 'lodash';

export default function NewsroomScreenRunTwitterRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.NewsroomScreenRunTwitter', {
		url: '/newsroom/twitter/:code',
		controllerAs: 'vm',
		controller: NewsroomScreenRunTwitterCtrl,
		templateUrl: '/ng/hub/Newsroom/Screen/Run/Twitter/NewsroomScreenRunTwitterCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Newsroom/Screen/Run/Twitter/NewsroomScreenRunTwitterCtrl.css'),
			$title: () => 'Newsroom :: Twitter Feed',
			newsroom: ApiResourcify.public('/newsrooms/screens/run/:code'),
		},
	});
}

class NewsroomScreenRunTwitterCtrl {
	constructor(newsroom, Pubnub, $timeout, $window, modal) {
		'ngInject';
		// 69 is the height of the header + the padding above the timeline
		this.screenHeight = $window.screen.height - 69;
		this.newsroom = newsroom;
		this.colors = _.pluck(this.newsroom.colors, 'bgColor');
		this.columns = [];
		// fills this.columns with any column that has a valid code
		this.newsroom.options.cols.forEach(this.parseWidgetCode.bind(this));
		Pubnub.awaitReload('newsroom_' + newsroom.code);
		this.isReady = false;
		$timeout(() => {
			// wait until next digest cycle when html will be rendered
			AssetManager.script('//platform.twitter.com/widgets.js?cb=' + +new Date());
		});
		$timeout(() => {
			this.isReady = true;
			if (this.newsroom.options.elements.fullscreen !== '0') {
				modal.fullscreen({
					text: 'Go fullscreen?',
					heading: 'Newsroom Mode',
					timeoutMs: 8000,
				});
			}
		}, 3000);
	}

	/*
	 * Get the widget headine and link from a widget embed code given by twitter.
	 * Link is modified by adding the `data-chrome` attribute to remove the
	 * header, footer, and scrollbar from each widget. Link is also modified to add
	 * a max height equal to `this.screenHeight`.
	 * Also generates a headline bg-color through `this.assignColor()`.
	 * Pushes item to `this.columns`: columnData = {
	 *				       link: '<a href="[twitterHref]" ... data-height="N" data-chrome="noheader nofooter noscrollbar">Will be used as Headline</a>',
	 *					   headline: "Will be used as Headline",
	 *					   headlineStyle: {"background-color": "#[some hex]"},
	 *				   }
	 */
	parseWidgetCode(column, idx) {
		if (column.code.length == 0) {
			return;
		}
		var matches = column.code.match(/<[^>]+>.+<\/a>/);
		if (!matches) {
			return;
		}
		// matches[0] is everything inside the opening <a>
		var twitterEl = matches[0];
		var columnData = {
			// add in screen's height
			link: twitterEl.replace(/>/, ' data-height=' + this.screenHeight + '>'),
			headline: column.headline,
			headlineStyle: { 'background-color': this.colors[idx % this.colors.length] },
			avatar: column.avatar,
		};
		// we have to add the data-chrome options (noheader, etc.) ourselves
		if (
			twitterEl.indexOf('noheader') === -1 &&
			twitterEl.indexOf('nofooter') === -1 &&
			twitterEl.indexOf('noscrollbar') === -1
		) {
			columnData.link = columnData.link.replace(/>/, " data-chrome='noheader nofooter noscrollbar'>");
		}
		this.columns.push(columnData);
	}
}
